module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofCell",
    class: [
      'dof-cell',
      _vm.clickActivied && 'active-cell',
      _vm.hasTopBorder && 'cell-top-border',
      _vm.hasBottomBorder && 'cell-bottom-border',
      _vm.hasMargin && 'cell-margin',
      _vm.hasBottomBorder && _vm.isIos ? 'ios-bottom-border' : ''
    ],
    style: _vm.outputCellStyle,
    on: {
      "click": _vm.cellClicked,
      "touchstart": _vm.startDrag,
      "touchmove": _vm.onDrag,
      "touchend": _vm.endDrag,
      "touchcancel": _vm.endDrag
    }
  }, [_vm._t("itemImg", [(_vm.itemImg && _vm.itemImg != '') ? _c('image', {
    staticClass: ["item-image"],
    style: _vm.imgStyle,
    attrs: {
      "src": _vm.itemImg
    }
  }) : _vm._e()]), _c('div', {
    class: [
      'dof-sub-cell',
      _vm.hasSubTopBorder && 'cell-sub-top-border',
      _vm.hasSubBottomBorder && 'cell-sub-bottom-border',
      _vm.hasSubBottomBorder && _vm.isIos ? 'ios-sub-bottom-border' : ''
    ],
    style: _vm.subCellStyle
  }, [_c('div', {
    class: ['dof-sub-cell-inner']
  }, [_c('div', {
    staticClass: ["content"]
  }, [_c('div', {
    staticClass: ["cell-title"]
  }, [_c('text', {
    class: [_vm.title && _vm.hasArrow ? 'cell-content' : 'cell-content-no-arrow', _vm.tag ? 'hasTag' : 'noTag']
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.tag && _vm.tag != '') ? _c('text', {
    staticClass: ["cell-title-btn"]
  }, [_vm._v(_vm._s(_vm.tag))]) : _vm._e()]), (_vm.desc) ? _c('text', {
    staticClass: ["cell-desc-text"],
    style: {
      color: _vm.descColor,
      lines: _vm.size == 'max' ? 2 : 1
    }
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()]), _vm._t("rightText", [(_vm.rightTip) ? _c('text', {
    staticClass: ["rightTip"]
  }, [_vm._v(_vm._s(_vm.rightTip))]) : _vm._e(), (_vm.rightText) ? _c('text', {
    staticClass: ["right-text"]
  }, [_vm._v(_vm._s(_vm.rightText))]) : (_vm.placeHolder) ? _c('text', {
    staticClass: ["placeholder-text"]
  }, [_vm._v(_vm._s(_vm.placeHolder))]) : _vm._e()]), _vm._t("switch")], 2), (_vm.hasArrow) ? _c('dof-image', {
    staticClass: ["cell-arrow-icon"],
    attrs: {
      "src": _vm.arrowIcon
    }
  }) : _vm._e()], 1), (_vm.rightWidth) ? _c('div', {
    staticClass: ["midea-swipe-cell__right"],
    style: _vm.rightStyle,
    on: {
      "click": _vm.rightClick
    }
  }, [_vm._t("right")], 2) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1b718726!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-cell2/index.vue
// module id = 574
// module chunks = 0 1